import axios from "axios";
import authHeader from "./auth-header";

require('dotenv').config();

const API_URL = process.env.REACT_APP_URL+"/api/emp/";

const getAllEmpleados = () => {
  return axios.get(API_URL , { headers: authHeader() });
};

const getAllEmpleadosAdmin = () => {
  return axios.get(API_URL + 'all', { headers: authHeader() });
};

const activateEmpleado = (dni) => {
  return axios.put(API_URL + dni + '/activate', {}, { headers: authHeader() });
};

const deactivateEmpleado = (dni) => {
  return axios.put(API_URL + dni + '/deactivate', {}, { headers: authHeader() });
};

const EmpeladoService = {
    getAllEmpleados,
    getAllEmpleadosAdmin,
    activateEmpleado,
    deactivateEmpleado
};

export default EmpeladoService;
